import React, {  useEffect } from "react";
import { createImportFlowPayload } from "../payload/generic.flow";
import {
  createCredRef,
} from "../../../../../../common/factory/credential.factory";

import { saveFlow } from "../../../../../../redux/actions/integrationActions";
import { setCurrentWizardData } from "../../../../../../redux/actions/wizardActions";
import { useDispatch, useSelector } from "react-redux";
import LoadingIndicator from "../../../../common/LoadingIndicator";
import SuccessIndicator from "../../../../common/SuccessIndicator";
/**
 * The useEffect will start the creation for the flows, this is dependent on the credentials to be createad first.
 *
 */
const CreateGenericImportFlow = () => {
  const dispatch = useDispatch();
  const currentData = useSelector((state) => state.wizard.currentData);
  const workspace = useSelector((state) => state.jiraAssets.workspace);
  const token = useSelector((state) => state.jiraAssets.token);
  const objectTypeName = useSelector(
    (state) => state.jiraAssets.objectTypeName
  );
  const importSource = useSelector((state) => state.jiraAssets.importSource);
  const selectedAssetSchema = useSelector(
    (state) => state.jiraAssets.selectedAssetSchema
  );
  const importSourceName = useSelector(
    (state) => state.jiraAssets.importSourceName
  );

  const createIntegrationFlow = (basicAuthRefId, tokenAuthRefId) => {
    //breaking condition if loop, do not remove!
    if(!basicAuthRefId || !tokenAuthRefId || currentData?.ihubConfigIsCreated){
      return false;
    }

    const flowPayload = createImportFlowPayload(
      currentData,
      importSourceName,
      selectedAssetSchema,
      objectTypeName,
      workspace,
      importSource.id,
      createCredRef(tokenAuthRefId),
      createCredRef(basicAuthRefId)
    );
    //console.log(flowPayload)
    dispatch(saveFlow(flowPayload, false));
    //console.log("flow", flowPayload);
    const updatedData = {
      ...currentData,
      ihubConfigIsCreated: true,
    };
    dispatch(setCurrentWizardData(updatedData));
  };

  const credMustExist=()=>{
    if(currentData && currentData.importCredentialsReferences && currentData.importCredentialsReferences.patTokenRefId 
      && currentData.importCredentialsReferences.assetImportTokenRefId){
        return true
      }
      return false
  }

  //Wait for tokens and credentials to be created, once that is done create the flow.
  useEffect(() => {   
    if (
      !currentData?.ihubConfigIsCreated &&
      credMustExist() &&
      workspace &&
      objectTypeName &&
      importSource &&
      selectedAssetSchema &&
      importSourceName &&
      token
    ) {
      createIntegrationFlow(currentData.importCredentialsReferences.patTokenRefId,currentData.importCredentialsReferences.assetImportTokenRefId)
    }
  }, [currentData, token]);

  return (
    <>
      <LoadingIndicator currentData={currentData} />
      <SuccessIndicator currentData={currentData} />
    </>
  );
};
export default CreateGenericImportFlow;